import { motion } from "framer-motion";
import { Apple, Smartphone } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { GOOGLE_PLAY_URL } from "@/lib/appLinks";

const HERO_DAY = "/assets/site/hero.webp";
const HERO_NIGHT = "/assets/site/hero-night.webp";

export default function FinalCta() {
  const { mode } = useTheme();
  const bg = mode === "night" ? HERO_NIGHT : HERO_DAY;
  const overlay =
    mode === "night"
      ? "linear-gradient(to bottom right, rgba(10,19,15,0.55), rgba(30,58,42,0.85))"
      : "linear-gradient(to bottom right, rgba(31,74,46,0.65), rgba(31,74,46,0.85))";

  return (
    <section
      data-testid="final-cta"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <img
        src={bg}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0" style={{ background: overlay }} />

      <div className="relative wrap grid md:grid-cols-2 gap-10 items-center">
        {/* Waving mascot (Tommy & Koboi - transparent PNG) */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85, rotate: -4 }}
          whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto"
        >
          <motion.img
            src="/assets/mascot/passport-otter.webp"
            alt="MyAdventure-Passport otter mascot holding a passport"
            className="w-[280px] md:w-[400px] h-auto drop-shadow-2xl"
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 3.6, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-white"
        >
          <div
            className="text-[12px] font-extrabold tracking-[0.18em] uppercase mb-4"
            style={{ color: "#FCD34D" }}
          >
            The Trailhead Awaits
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight mb-5">
            Ready to collect your first stamp?
          </h2>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            Sign up in seconds. No credit card required for the free plan.
            Tommy &amp; Koboi will be waiting for you at the trailhead.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-amber text-base py-4 px-7"
              data-testid="final-cta-btn"
            >
              <Smartphone className="w-5 h-5" /> Get it on Google Play
            </a>
            <a
              href="https://apps.apple.com/my/app/myadventure-passport/id6803114683"
              target="_blank"
              rel="noopener noreferrer"
              className="btn text-base py-4 px-7"
              style={{
                background: "rgba(255,255,255,0.08)",
                color: "rgba(255,255,255,0.95)",
                border: "1px solid rgba(255,255,255,0.28)",
              }}
              data-testid="final-cta-ios"
            >
              <Apple className="w-5 h-5" /> Download on the App Store
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
